import { prop, required } from '@rxweb/reactive-form-validators';
import { Resource } from 'src/app/core/jsonapi/resource';

export class VoipScheduleRule extends Resource {
    public override type = 'voipScheduleRules';

    @prop()
    @required()
    public scheduleType: string = 'Normal';

    @prop()
    @required()
    public dayOfWeek!: number;

    @prop()
    @required()
    public startTime!: string;

    @prop()
    @required()
    public endTime!: string;
}